


































import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyKey from "@/components/company-key";
import FormHeader from '../../molecules/FormHeader.vue'
import router from '../../../router'
export default createComponent({
   setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }
    const getFavoriteUser = company.getFavoriteUser
    onMounted(() => {
      getFavoriteUser()
    });
    const companyInfor = computed(() => company.tableFavoriteUser);
    const toFavouriteUser = (userId: any, jobId: any, commonId: any) => {
      router.push(`/company_detail/user/customer_id/${userId}/job_application_id/${jobId}/common_id/${commonId}`)
    }
    return {
      companyInfor,
      toFavouriteUser
    };
  },
  components: {
    FormHeader
  },
})
